import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from '../../../components/withRouter';
import { StudentCompetencySubcompetencyList } from '../../shared/student-competency';

class MyCompetencySubcompetencyList extends React.Component {

  render() {
    return (
      <StudentCompetencySubcompetencyList/>
    );
  }
}

const mapStateToProps = (state) => ({
});

const mapDispatchToProps = (dispatch) => ({
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(MyCompetencySubcompetencyList));
